import React from 'react';
import BookingConfigurator from '../../components/BookingConfigurator/BookingConfigurator';
import './Services.css';

const PageLayout = (props) => {
    const { title, heroImage, icon, description, services, category, handleServiceChange, setCurrentPage, agencySettings } = props;
    const companyName = agencySettings?.company_name || "Ma clé 31";

    return (
        <div className="service-page-container">
            <header className="service-hero">
                <div className="service-hero-content">
                    <div className="service-hero-text">
                        <div className="technical-badge">
                            <span>{icon}</span> Expertise {category}
                        </div>
                        <h2>{title}</h2>
                        {description.map((p, i) => <p key={i}>{p}</p>)}
                    </div>
                    <div className="service-hero-image-wrapper">
                        <img src={heroImage} alt={title} />
                    </div>
                </div>
            </header>

            <section className="service-solutions">
                <div className="section-title-tech gold" style={{ marginBottom: '3rem' }}>
                    <span className="title-text-tech">Nos Solutions</span>
                    <div className="title-line gold"></div>
                </div>

                <div className="solutions-grid">
                    {services.map(s => (
                        <div key={s.id} className="solution-card-premium">
                            <div className="solution-meta">
                                <h3>{s.name}</h3>
                                <span className="solution-tag">{s.sub_category || category}</span>
                            </div>

                            <p className="solution-desc">
                                {s.description || `Prestation spécialisée pour votre véhicule. Intervention rapide et expertise technique garantie par ${companyName}.`}
                            </p>

                            {s.duration && (
                                <div className="solution-details">
                                    <span style={{ color: '#94a3b8', fontSize: '0.85rem' }}>⏱️ Durée estimée : {s.duration}</span>
                                </div>
                            )}

                            <div className="solution-footer">
                                <div className="solution-price">
                                    <span className="label">À partir de</span>
                                    <span className="value">{s.base_price}€</span>
                                </div>
                                <button
                                    className="hero-cta small gold"
                                    onClick={() => {
                                        handleServiceChange({ target: { id: s.id, checked: true } });
                                        setCurrentPage('devis');
                                        window.scrollTo({ top: 0, behavior: 'smooth' });
                                    }}
                                >
                                    Choisir
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            {/* INTEGRATED CONFIGURATOR */}
            <div className="service-booking-section" style={{ marginTop: '5rem' }}>
                <div className="section-title-tech gold" style={{ marginBottom: '3rem' }}>
                    <span className="title-text-tech">Réserver une intervention</span>
                    <div className="title-line gold"></div>
                </div>
                <BookingConfigurator {...props} />
            </div>
        </div>
    );
};

export const Cles = (props) => {
    const { agencySettings } = props;
    const companyName = agencySettings?.company_name || "Ma clé 31";
    const services = props.dbServices.filter(s => s.category === 'Clés');
    
    return (
        <PageLayout
            {...props}
            title="Reproduction de clés de précision"
            category="Clés"
            icon="🔑"
            heroImage="https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?q=80&w=2070&auto=format&fit=crop"
            description={[
                `${companyName} est votre expert toulousain pour le double et la réparation de vos clés automobiles.`,
                "Qu'il s'agisse de clés manuelles classiques ou de télécommandes électroniques sophistiquées, nous maîtrisons les protocoles de cryptage les plus récents.",
                "Intervention soignée, matériel de pointe et service d'urgence pour vous assurer une mobilité sans interruption."
            ]}
            services={services}
        />
    );
};

export const Ethanol = (props) => {
    const { agencySettings } = props;
    const companyName = agencySettings?.company_name || "Ma clé 31";
    const services = props.dbServices.filter(s => s.category === 'Éthanol');
    
    return (
        <PageLayout
            {...props}
            title="Reprogrammation Éthanol E85"
            category="Ingénierie"
            icon="⛽"
            heroImage="https://images.unsplash.com/photo-1517524008697-84bbe3c3fd98?q=80&w=2600&auto=format&fit=crop"
            description={[
                "Optimisez vos dépenses en carburant tout en améliorant la souplesse de votre moteur.",
                `Nos experts chez ${companyName} réalisent des cartographies sur-mesure adaptées à chaque motorisation pour une conversion E85 sécurisée et performante.`,
                "Réduisez votre empreinte carbone et réalisez jusqu'à 2000€ d'économies annuelles sur vos pleins."
            ]}
            services={services}
        />
    );
};

export const Diagnostic = (props) => {
    const { agencySettings } = props;
    const companyName = agencySettings?.company_name || "Ma clé 31";
    const services = props.dbServices.filter(s => s.category === 'Diagnostic');
    
    return (
        <PageLayout
            {...props}
            title="Expertise & Diagnostic Profond"
            category="Diagnostic"
            icon="💻"
            heroImage="https://images.unsplash.com/photo-1550989460-0adf9ea622e2?q=80&w=2574&auto=format&fit=crop"
            description={[
                `Identifiez l'origine précise de vos pannes grâce aux outils de diagnostic constructeur utilisés par ${companyName}.`,
                "Nous analysons l'ensemble des réseaux multiplexés de votre véhicule pour détecter les anomalies électroniques les plus complexes.",
                "Effacement des codes défauts, tests d'actionneurs et rapports détaillés pour une maintenance préventive efficace."
            ]}
            services={services}
        />
    );
};
